"use client";
import dynamic from "next/dynamic";
import Image from "next/image";
import { Suspense } from "react";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import { ImageSliderProps } from "types/tiles";
const ImageSlider = dynamic(() => import("./ImageSlider"), { ssr: false });

interface TestimonialProps {
  quote: string;
  client: string;
  location: string;
  mediaType: "image" | "slider";
  bgColor: string;
  wrapperClass?: string;
  src: string;
  images?: ImageSliderProps[];
}

const Testimonial: React.FC<TestimonialProps> = ({
  quote,
  wrapperClass,
  client,
  src,
  images,
  mediaType,
  bgColor = "#F2F0E6"
}) => {
  return (
    <section
      id="testimonial-37"
      style={{
        backgroundColor: bgColor
      }}
    >
      <MaxWidthWrapper className={wrapperClass}>
        <div
          className="relative"
          style={{
            backgroundColor: bgColor
          }}
        >
          <div className="m-auto grid grid-cols-1 items-center gap-x-6 text-left align-middle md:grid-cols-10">
            <div className="col-span-1 md:col-span-5 md:pl-20">
              <div className="pb-4">
                <div className="flex items-center justify-center text-center lg:items-start lg:justify-start lg:text-left">
                  <h3 className=" inline-block text-center text-sm font-semibold uppercase tracking-wide !text-[#e5b04f] lg:text-left">
                    {client}
                  </h3>
                </div>
              </div>
              <div className="relative">
                <svg
                  className="absolute -left-[45px] top-0 mt-[-2px] h-8 text-primary-700 opacity-20"
                  viewBox="0 0 24 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <blockquote className="text-left">
                  <p className="mb-12 text-center font-heading text-lg text-primary-700 lg:text-left   lg:text-[38px] lg:leading-[46px]">
                    {quote}
                  </p>
                </blockquote>
              </div>
            </div>

            <div className="relative order-first col-span-1 mb-6 rounded-2xl md:order-first md:col-span-5  md:mb-0 md:min-h-[500px]">
              {mediaType === "image" && (
                <Image
                  src={src}
                  alt="Featured Image"
                  fill
                  style={{
                    objectFit: "cover"
                  }}
                  sizes="(max-width: 768px) 100vw, 50vw"
                />
              )}

              {mediaType === "slider" && images && (
                <Suspense>
                  <ImageSlider images={images} bgColor={bgColor} />
                </Suspense>
              )}
            </div>
          </div>
        </div>
      </MaxWidthWrapper>
    </section>
  );
};

export default Testimonial;
